import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'

/**
 * Who may use the ESP pilot: P360 Tester only. The pilot has no role model of its own, so
 * this single check stands in for one — keep every ESP surface behind it so the audience
 * stays in step as the pilot grows.
 */
export const useEspAccess = (): boolean => {
  const { isP360Tester } = useUserRoles()

  return isP360Tester
}
